(function () {
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function drawer() { return document.getElementById('cart-drawer'); }
  function isOpen() { var d = drawer(), dl = d && d.querySelector('dialog'); return !!(dl && dl.open); }
  function openDrawer() { if (isOpen()) return true; var d = drawer(); if (d && typeof d.open === 'function') { d.open(); return true; } return false; }
  function closeDrawer() { var d = drawer(); if (d && typeof d.close === 'function') d.close(); }
  function money(c) { return '$' + (c / 100).toFixed(2); }

  async function smAdd(items, btn) {
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    var wasOpen = isOpen();
    var ids = Array.from(new Set(Array.from(document.querySelectorAll('cart-items-component')).map(function (e) { return e.dataset.sectionId; }).filter(Boolean)));
    try {
      var r = await fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items, sections: ids.join(','), sections_url: location.pathname }) });
      var j = await r.json();
      if (!r.ok) throw j;
      var cart = await (await fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })).json();
      try {
        var ev = await import('@shopify/events');
        var d = ev.CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(new ev.CartLinesUpdateEvent({ action: wasOpen ? 'update' : 'add', context: 'cart', lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }), promise: d.promise }));
        d.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: j.sections, items: cart.items, itemCount: cart.item_count, source: 'sm-add', didError: false } });
        if (!wasOpen && !openDrawer()) location.href = root() + 'cart';
      } catch (e) {
        var u = new URL(location.href); u.searchParams.set('sm_cart', '1'); location.href = u.toString(); return;
      }
    } catch (err) {
      if (btn) { btn.classList.add('is-error'); setTimeout(function () { btn.classList.remove('is-error'); }, 1800); }
    }
    if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
  }
  window.smAdd = smAdd;

  document.addEventListener('click', function (e) {
    var dlg = e.target;
    if (dlg && dlg.tagName === 'DIALOG' && dlg.closest('#cart-drawer')) {
      var panel = dlg.querySelector('.cart-drawer__inner');
      var r = (panel || dlg).getBoundingClientRect();
      var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) closeDrawer();
    }
  }, true);

  var pop;
  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }
  function openPop(el) {
    if (!pop) {
      pop = document.createElement('dialog');
      pop.className = 'smpop';
      document.body.appendChild(pop);
      pop.addEventListener('click', function (e) { if (e.target === pop || e.target.closest('.smpop__close')) pop.close(); });
    }
    pop.innerHTML = '<div class="smpop__box"><button type="button" class="smpop__close" aria-label="Close">&times;</button>' +
      '<img class="smpop__img" src="' + el.getAttribute('data-smpop-img') + '" alt="' + esc(el.getAttribute('data-smpop-title')) + '">' +
      '<div class="smpop__body"><p class="smpop__title">' + esc(el.getAttribute('data-smpop-title')) + '</p><span class="smpop__price">' + esc(el.getAttribute('data-smpop-price')) + '</span></div></div>';
    pop.showModal();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-smpop]');
    if (!t) return;
    e.preventDefault();
    openPop(t);
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sm-add]');
    if (!b) return;
    e.preventDefault();
    smAdd([{ id: Number(b.getAttribute('data-sm-add')), quantity: 1 }], b);
  });

  // Frequently bought together: live total with tier discount ($50 15%, $75 20%, $100 30%)
  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('.smfbt');
    if (!box) return;
    var total = 0, n = 0;
    box.querySelectorAll('input[type=checkbox]').forEach(function (c) { var it = c.closest('.smfbt__item'); if (it) it.classList.toggle('is-off', !c.checked); if (c.checked) { total += Number(c.dataset.price); n++; } });
    var off = total >= 10000 ? 30 : total >= 7500 ? 20 : total >= 5000 ? 15 : 0;
    var final = total - Math.round(total * off / 100);
    var t = box.querySelector('[data-fbt-total]'); if (t) t.textContent = money(final);
    var was = box.querySelector('[data-fbt-was]'); if (was) { was.textContent = money(total); was.hidden = !off; }
    var tier = box.querySelector('[data-fbt-tier]'); if (tier) { tier.textContent = off ? off + '% off applied at checkout' : ''; tier.hidden = !off; }
    var btn = box.querySelector('.smfbt__btn'); if (btn) { btn.disabled = n === 0; var l = btn.querySelector('[data-fbt-label]'); if (l) l.textContent = n > 1 ? 'Add all ' + n + ' to cart' : 'Add to cart'; }
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.smfbt__btn');
    if (!b) return;
    e.preventDefault();
    var items = [];
    b.closest('.smfbt').querySelectorAll('input[type=checkbox]:checked').forEach(function (c) { items.push({ id: Number(c.value), quantity: 1 }); });
    if (items.length) smAdd(items, b);
  });

  var syncing = false;
  function qtyScope(el) { return el.closest('.product-details, .product-information, main') || document; }
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r.matches || !r.matches('.smqty input[type=radio]')) return;
    var q = Number(r.value) || 1;
    syncing = true;
    qtyScope(r).querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = q;
      i.dispatchEvent(new Event('input', { bubbles: true }));
      i.dispatchEvent(new Event('change', { bubbles: true }));
    });
    syncing = false;
  });
  function syncRadios(from) {
    if (syncing) return;
    var scope = qtyScope(from);
    var input = scope.querySelector('input[name="quantity"]');
    var box = scope.querySelector('.smqty');
    if (!input || !box) return;
    var q = String(Number(input.value) || 1);
    box.querySelectorAll('input[type=radio]').forEach(function (r) { r.checked = r.value === q; });
  }
  ['input', 'change', 'quantity-selector:update'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('quantity-selector-component, .quantity-selector')) return;
      if (t.closest('#cart-drawer, cart-items-component')) return;
      setTimeout(function () { syncRadios(t); }, 0);
    });
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('.smf__form')) return;
    e.preventDefault();
    var fd = new FormData(f);
    smAdd([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }], f.querySelector('button'));
  });

  function maybeOpen() {
    var u = new URL(location.href);
    if (u.searchParams.get('sm_cart') === '1') {
      u.searchParams.delete('sm_cart');
      history.replaceState(null, '', u.toString());
      var tries = 0;
      (function tryOpen() { if (!openDrawer() && tries++ < 20) setTimeout(tryOpen, 150); })();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maybeOpen); else maybeOpen();
})();
